export default __webpack_public_path__ + "static/media/banner2.0eb76f62.png";